import { BridgeApplication } from '../mockData/mockApplicationsGridData';
import { ApplicationsGrid } from './components/ApplicationsGrid';

export interface ApplicationsProps {
    data: BridgeApplication[];
}

export const Applications = ({ data }: ApplicationsProps) => {
    return (
        <div style={{ paddingTop: '20px' }}>
            <div style={{ paddingBottom: '8px', fontWeight: 600 }}>
                <i>Applications</i>
            </div>
            <div>
                <ApplicationsGrid data={data} />
            </div>
        </div>
    );
};
